import { PopupCat, PopupScreen } from '../../utils/enums'

const Type = {
  SET_TOOL_POPUP: 'setToolPopup',
  SET_IS_AUTH_POPUP: 'setIsAuthPopup',
  SET_TAB: 'setTab',
  SET_SCREEN: 'setScreen',
  SET_ACTION_CONFIG: 'setActionConfig',
  RESET_ACTION_CONFIG: 'resetActionConfig',
  SET_TOOL_OBJ: 'setToolObj',
  SET_IS_JOB_LOADING: 'setIsJobLoading',
  SET_IS_VALID: 'setIsValid',
  SET_SOURCE: 'setSource',
}
export const initializeState = {
  toolPopup: false,
  isAuthPopup: false,
  isJobLoading: false,
  isValid: true,
  tab: PopupCat.RECENT,
  screen: PopupScreen.Action,
  actionConfig: {},
  toolObj: {},
  source: {},
}
export const setToolPopup = (payload) => ({
  type: Type.SET_TOOL_POPUP,
  payload,
})
export const setIsAuthPopup = (payload) => ({
  type: Type.SET_IS_AUTH_POPUP,
  payload,
})
export const setTab = (payload) => ({
  type: Type.SET_TAB,
  payload,
})
export const setScreen = (payload) => ({
  type: Type.SET_SCREEN,
  payload,
})

export const setActionConfig = (payload = {}) => ({
  type: Type.SET_ACTION_CONFIG,
  payload,
})
export const resetActionConfig = () => ({
  type: Type.RESET_ACTION_CONFIG,
})

export const setToolObj = (payload = {}) => ({
  type: Type.SET_TOOL_OBJ,
  payload,
})

export const setIsJobLoading = (payload) => ({
  type: Type.SET_IS_JOB_LOADING,
  payload,
})

export const setIsValid = (payload) => ({
  type: Type.SET_IS_VALID,
  payload,
})

export const setSource = (payload) => ({
  type: Type.SET_SOURCE,
  payload,
})

function reducerFn(state, action) {
  switch (action.type) {
    case Type.SET_TOOL_POPUP: {
      return {
        ...state,
        toolPopup: action.payload,
      }
    }
    case Type.SET_IS_AUTH_POPUP: {
      return {
        ...state,
        isAuthPopup: action.payload,
      }
    }
    case Type.SET_TAB: {
      return {
        ...state,
        tab: action.payload,
      }
    }
    case Type.SET_SCREEN: {
      return {
        ...state,
        screen: action.payload,
      }
    }
    case Type.SET_ACTION_CONFIG: {
      return {
        ...state,
        actionConfig: { ...state.actionConfig, ...action.payload },
      }
    }
    case Type.RESET_ACTION_CONFIG: {
      return {
        ...state,
        actionConfig: initializeState.actionConfig,
      }
    }
    case Type.SET_TOOL_OBJ: {
      return {
        ...state,
        toolObj: action.payload,
      }
    }
    case Type.SET_IS_JOB_LOADING: {
      return {
        ...state,
        isJobLoading: action.payload,
      }
    }
    case Type.SET_IS_VALID: {
      return {
        ...state,
        isValid: action.payload,
      }
    }
    case Type.SET_SOURCE: {
      return {
        ...state,
        source: action.payload,
      }
    }
    default:
      return state
  }
}

export { Type, reducerFn }
